import { render, staticRenderFns } from "./ShopFilter.vue?vue&type=template&id=7245e815&scoped=true&"
import script from "./ShopFilter.vue?vue&type=script&lang=js&"
export * from "./ShopFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShopFilter.vue?vue&type=style&index=0&id=7245e815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245e815",
  null
  
)

export default component.exports